// https://github.com/ReactTraining/react-router/issues/5072

import { connect } from 'react-redux'
import { Switch } from 'react-router'

const mapStateToProps = (state) => {
    return {
        location: state.router.location
    }
}

const ConnectedSwitch = connect(mapStateToProps)(Switch)

export default ConnectedSwitch



// WEBPACK FOOTER //
// src/components/auth/connected-switch.js